import { createReducer } from '@reduxjs/toolkit'

import { CLEAR_ACCOUNT_TYPE, SELECT_ACCOUNT_TYPE } from '../../../common/constants/reduxConstants'

type RegisterProviderState = {
  accountType?: string
}

const initialState = {}

export default createReducer<RegisterProviderState>(initialState, (builder) => {
  builder.addCase(SELECT_ACCOUNT_TYPE, (state, action: any) => {
    state.accountType = action.payload
    return state
  })
  builder.addCase(CLEAR_ACCOUNT_TYPE, (state) => {
    state.accountType = undefined
    return state
  })
})
